<template>
  <div>
    <!-- Documents table -->
    <div class="card"
         qid="documents-section"
         id="update_documents"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="measure-table-title" v-if="!showOnTask">
                {{ $t('maintenance.third_parties.documents.title') }}
              </h5>
              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_documents')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_documents')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_documents')">
                  <GuideButton :guide="getGuide('update_documents')"></GuideButton>
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <span class="btn btn-success float-right cursor-pointer"
                  @click="showCreateDocumentModal()"
                  qid="retention-rule-create-button"
                  v-if="isGranted([permissions.THIRD_PARTY_DOCUMENT_CREATE, permissions.THIRD_PARTY_DOCUMENT_CREATE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.third_parties.documents.add_new') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col"
                class="cursor-pointer"
                @click="selectSort('name')"
                qid="sort-s-name"
            >
              {{ $t('activities.measures.table.name') }}
              <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
              </span>
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.category') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.start_date') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.end_date') }}
            </th>
            <th scope="col" class="text-center">
              {{ $t('maintenance.third_parties.documents.attachments') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.signed') }}
            </th>
            <th scope="col"
                class="cursor-pointer"
                @click="selectSort('updated_at')"
                qid="sort-s-name"
            >
              {{ $t('system.last_updated') }}
              <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
              </span>
            </th>
            <th width="180"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(object, index) in documentTableItems">
              <td>
                <span
                    @click="openViewDocumentListModal(object)"
                    class="btn btn-link btn-sm text-left cursor-pointer"
                    v-if="object.latest_version && object.latest_version.name"
                >
                    {{ object.latest_version.name }}
                </span>
              </td>
              <td>
                <span v-if="object.latest_version && object.latest_version.category" class="text-normal">
                  <font-awesome-icon icon="shapes"/>
                  {{ object.latest_version.category }}
                </span>
              </td>
              <td>
                <span v-if="object.latest_version && object.latest_version.start_date" class="text-normal">
                  {{ object.latest_version.start_date | formatDate }}
                </span>
              </td>
              <td>
                <span v-if="object.latest_version && object.latest_version.end_date" class="text-normal">
                  {{ object.latest_version.end_date | formatDate }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="(object.latest_version && object.latest_version.media && object.latest_version.media.length) || object.latest_version && object.latest_version.links && object.latest_version.links.length">
                  <font-awesome-icon icon="paperclip"/>
                </span>
              </td>
              <td>
                <span v-if="object.latest_version && object.latest_version.signed == 'yes'" class="text-normal">
                  <font-awesome-icon icon="check-circle" class="icon-success mr-1"/>
                  {{ $t('system.yes') }}
                </span>
                <span v-if="object.latest_version && object.latest_version.signed == 'pending'" class="text-normal">
                  <font-awesome-icon icon="info-circle" class="icon-info"/>
                  {{ $t('system.pending') }}
                </span>
              </td>
              <td>
                <span v-if="object.latest_version" class="text-normal">
                  {{ object.latest_version.updated_at | formatDate }}
                </span>
              </td>
              <td class="text-right">
                <span v-if="isGranted([permissions.THIRD_PARTY_DOCUMENT_EDIT, permissions.THIRD_PARTY_DOCUMENT_EDIT_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                      class="btn btn-edit cursor-pointer"
                      qid="edit-p-modal"
                      @click="showEditDocumentsModal(object.latest_version)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span @click="openViewDocumentListModal(object)"
                      class="btn btn-view cursor-pointer"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-delete cursor-pointer"
                      qid="delete-document-modal"
                      @click="showDocumentConfirmDeleteModal(object)"
                      v-if="isGranted([permissions.THIRD_PARTY_DOCUMENT_DELETE, permissions.THIRD_PARTY_DOCUMENT_DELETE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!measureLoading && !documentTableItems.length" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <div class="card-body">
        <div class="pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                  v-model="perPage"
                  :options="perPageOptions"
                  track-by="value"
                  label="value"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="create-org-form-organization-level"
                  @select="perPageChanged"
                  :placeholder="selectedPerPage"
                  @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- Delete document modal template -->
    <b-modal ref="delete-document" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-document-title">
          {{ $t('activities.measures.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.measures.delete.description') }}
        <span v-if="itemToDelete.measure">{{ itemToDelete.measure.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.measures.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideDocumentConfirmDeleteModal"
                  qid="delete-document-cancel-button"
        >
          {{ $t('activities.measures.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteDocument(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-document-submit-button"
        >
          {{ $t('activities.measures.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Add new document -->
    <b-modal ref="add-document" hide-footer @hide="hideCreateDocumentModal" size="xl">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.add_modal_title')}}
        </h4>
      </div>

      <b-form @submit="formSubmit" qid="create-ac-form">
        <div class="form-container">
          <div class="row">

            <div class="col-sm-12 pl-5 pr-5" v-if="error.length">
              <b-alert v-if="error.length"
                       show
                       variant="danger"
                       qid="create-ac-error"
              >
                {{ error }}
              </b-alert>
            </div>

            <div class="col-sm-6 pl-5 pr-3">
              <b-form-group>
                <label qid="create-tp-name-label">
                  {{ $t('maintenance.third_parties.create.name_label') }}
                </label>
                <span class="text-red">*</span>
                <b-form-input
                  qid="create-tp-form-name"
                  type="text"
                  v-model="form.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.third_parties.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
                <label qid="create-do-type-label">
                  {{ $t('maintenance.data_objects.create.category_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="form.category"
                    :options="categoryItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                    label="category"
                    :preserveSearch="true"
                    @search-change="handleCategoryInput"
                    qid="create-do-form-category"
                >
                  <template slot="noResult" slot-scope="props">
                    {{ $t('maintenance.data_objects.create.category_no_results') }}
                  </template>
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-name-label">
                  {{ $t('maintenance.third_parties.documents.start_date_label') }}
                </label>
                <span class="text-red">*</span>
                <datepicker
                    class="date-picker"
                    qid="form-due-date"
                    calendar-class="left"
                    v-model="form.start_date"
                    :clear-button="true"
                    :placeholder="$t('maintenance.measures.values.date')"
                ></datepicker>
              </b-form-group>

              <div class="row mt-2 mb-2">
                <div class="col-sm-6">
                  <label>
                    {{ $t('maintenance.third_parties.documents.has_end_date_label') }}
                  </label>
                </div>
                <div class="col-sm-6 text-right">
                  <b-form-radio-group
                    v-model="hasEndDate"
                    :options="checklistOptions"
                  ></b-form-radio-group>
                </div>
              </div>

              <b-form-group v-if="hasEndDate">
                <label qid="create-s-name-label">
                  {{ $t('maintenance.third_parties.documents.end_date_label') }}
                </label>
                <datepicker
                    class="date-picker"
                    qid="form-due-date"
                    calendar-class="left"
                    v-model="form.end_date"
                    :clear-button="true"
                    :placeholder="$t('maintenance.measures.values.date')"
                ></datepicker>
              </b-form-group>

              <b-form-group class="mt-3">
                <label qid="create-tp-attachments-label">
                  {{ $t('maintenance.third_parties.create.attachments') }}
                  &nbsp;
                  <span class="text-muted">({{ $t('attachments.file_size_label_30') }})</span>
                </label>
                <span class="text-red">*</span>
                <br>
                <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
                <label class="btn btn-secondary cursor-pointer" qid="create-tp-attachments-button">
                  <input type="file"
                         name="fileupload"
                         value="fileupload"
                         multiple
                         id="file"
                         @change="onFileChange"
                         @click="resetFile"
                  >
                  <span>
                    <font-awesome-icon icon="cloud-upload-alt" />
                    {{ $t('system.upload') }}
                  </span>
                </label>
              </b-form-group>
              <b-form-group>
                <label qid="create-tp-link-label">
                  {{ $t('maintenance.third_parties.create.links_label') }}
                </label>
                <span class="text-red">*</span>
                <p v-for="(link, index) in form.links">
                  <span class="float-right text-muted cursor-pointer"
                        @click="removeLinkItem(index)"
                        qid="create-tp-link-remove"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
                </p>
                <div>
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLinkName"
                    :placeholder="inputLink ? inputLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>
                </div>
                <span class="btn btn-link cursor-pointer float-right"
                      @click="handleLink"
                      qid="create-tp-add-link"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                </span>
              </b-form-group>
            </div>

            <div class="col-sm-6 pl-3 pr-5">
              <b-form-group>
                <label qid="create-do-contact-label">
                  {{ $t('maintenance.third_parties.documents.signed_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="form.signed"
                    :options="signedItems"
                    :placeholder="$t('maintenance.third_parties.documents.signed_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-do-form-classification"
                >
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'yes'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'pending'" style="background:white;border-radius:50%;"/>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'yes'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'pending'" style="background:white;border-radius:50%;"/>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </b-form-group>
            </div>
          </div>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateDocumentModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('activities.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('activities.measures.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit document  -->
    <b-modal ref="edit-document" hide-footer @hide="hideEditDocumentModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.edit_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="editError.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ editError }}
      </b-alert>
      <b-form @submit="formEditSubmit" qid="create-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-tp-name-label">
              {{ $t('maintenance.third_parties.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="create-tp-form-name"
              type="text"
              v-model="editForm.name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.third_parties.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
            <label qid="create-do-type-label">
              {{ $t('maintenance.third_parties.documents.category') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="editForm.category"
                :options="categoryItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                label="category"
                track-by="category"
                :preserveSearch="true"
                @search-change="handleCategoryInput"
                qid="create-do-form-category"
            >
              <template slot="noResult" slot-scope="props">
                {{ $t('maintenance.data_objects.create.category_no_results') }}
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-s-name-label">
              {{ $t('maintenance.third_parties.documents.start_date_label') }}
            </label>
            <span class="text-red">*</span>
            <datepicker
                class="date-picker"
                qid="form-due-date"
                calendar-class="left"
                v-model="editForm.start_date"
                :clear-button="true"
                :placeholder="$t('maintenance.measures.values.date')"
            ></datepicker>
          </b-form-group>
          <b-form-group>
            <label qid="create-s-name-label">
              {{ $t('maintenance.third_parties.documents.end_date_label') }}
            </label>
            <datepicker
                class="date-picker"
                qid="form-due-date"
                calendar-class="left"
                v-model="editForm.end_date"
                :clear-button="true"
                :placeholder="$t('maintenance.measures.values.date')"
            ></datepicker>
          </b-form-group>
          <b-form-group>
            <label qid="create-do-contact-label">
              {{ $t('maintenance.third_parties.documents.signed_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="editForm.signed"
                :options="signedItems"
                :placeholder="$t('maintenance.third_parties.documents.signed_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-do-form-classification"
            >
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'yes'" style="background:white;border-radius:50%;"/>
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'pending'" style="background:white;border-radius:50%;"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'yes'" style="background:white;border-radius:50%;"/>
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'pending'" style="background:white;border-radius:50%;"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditDocumentModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('activities.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('system.save') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- View document modal -->
    <b-modal ref="view-document" hide-footer @hide="hideViewDocumentModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.view_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <div v-if="selectedViewItem">
        <label qid="create-tp-name-label" class="mt-3">
          {{ $t('maintenance.third_parties.create.name_label') }}
        </label>
        <br>
        <span qid="network-name">
          {{ selectedViewItem.name }}
        </span>
        <br>

        <label qid="create-do-type-label" class="mt-3">
          {{ $t('maintenance.data_objects.create.category_label') }}
        </label>
        <br>
        <span qid="network-name">
          {{ selectedViewItem.category }}
        </span>
        <br>

        <label qid="create-s-name-label" class="mt-3">
          {{ $t('maintenance.third_parties.documents.start_date_label') }}
        </label>
        <br>
        <span qid="network-name">
          {{ selectedViewItem.start_date | formatDate }}
        </span>
        <br>

        <label qid="create-s-name-label" class="mt-3">
          {{ $t('maintenance.third_parties.documents.end_date_label') }}
        </label>
        <br>
        <span qid="network-name">
          {{ selectedViewItem.end_date | formatDate }}
        </span>
        <br>
      </div>

      <div class="mt-3" v-if="selectedViewItem && selectedViewItem.media && selectedViewItem.media.length">
        <p class="text-dark">{{ $t('attachments.label') }}</p>
        <p v-for="(file, index) in selectedViewItem.media">
          <span class="mr-3 float-right text-muted cursor-pointer"
                @click="downloadMedia(file)"
                qid="download-media"
          >
            <font-awesome-icon icon="cloud-download-alt" />
          </span>
          <a @click="downloadMedia(file)" qid="create-tp-media-item">
            {{ file.file_name }}
          </a>
        </p>
        <br>
      </div>

      <div class="mt-3" v-if="selectedViewItem && selectedViewItem.links && selectedViewItem.links.length">
        <p class="text-dark">{{ $t('links.label') }}</p>
        <div v-if="selectedViewItem.links">
          <p v-for="(link, index) in selectedViewItem.links" >
            <a :href="link.url" target="_blank" qid="create-tp-link-item">
              {{ link.name ? link.name : link.url }}
            </a>
          </p>
        </div>
        <br>
      </div>

      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideViewDocumentModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>

      </div>

    </b-modal>


    <!-- View document list modal -->
    <b-modal ref="view-document-list" hide-footer @hide="hideViewDocumentListModal" size="xl">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.view_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <div class="text-right">
        <button class="btn btn-secondary"
                @click="showCreateDocumentModal(selectedItem)"
                qid="retention-rule-create-button"
                v-if="isGranted([permissions.THIRD_PARTY_DOCUMENT_CREATE, permissions.THIRD_PARTY_DOCUMENT_CREATE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
        >
          <font-awesome-icon icon="plus"/> {{ $t('maintenance.third_parties.documents.add_new_version') }}
        </button>
      </div>

      <table class="table table-responsive-md" v-if="documentSingleTableItems && documentSingleTableItems.length">
        <thead>
        <tr>
          <th scope="col">
            {{ $t('activities.measures.table.name') }}
          </th>
          <th scope="col">
            {{ $t('maintenance.third_parties.documents.start_date') }}
          </th>
          <th scope="col">
            {{ $t('maintenance.third_parties.documents.end_date') }}
          </th>
          <th scope="col" class="text-center">
            {{ $t('maintenance.third_parties.documents.attachments') }}
          </th>
          <th scope="col">
            {{ $t('maintenance.third_parties.documents.signed') }}
          </th>
          <th scope="col">
            {{ $t('system.last_updated') }}
          </th>
          <th width="180"></th>
        </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <button
                  @click="openViewDocumentModal(documentSingleTableItems[0])"
                  class="btn btn-link btn-sm text-left"
              >
                {{ documentSingleTableItems[0].name }}
              </button>
            </td>
            <td>
              <span v-if="documentSingleTableItems[0].start_date">
                {{ documentSingleTableItems[0].start_date | formatDate }}
              </span>
            </td>
            <td>
              <span v-if="documentSingleTableItems[0].end_date">
                {{ documentSingleTableItems[0].end_date | formatDate }}
              </span>
            </td>
            <td class="text-center">
              <span v-if="(documentSingleTableItems[0].media && documentSingleTableItems[0].media.length) || (documentSingleTableItems[0].links && documentSingleTableItems[0].links.length)">
                <font-awesome-icon icon="paperclip"/>
              </span>
            </td>
            <td>
              <span v-if="documentSingleTableItems[0].signed == 'yes'">
                <font-awesome-icon icon="check-circle" class="icon-success mr-1"/>
                {{ $t('system.yes') }}
              </span>
              <span v-if="documentSingleTableItems[0].signed == 'pending'">
                <font-awesome-icon icon="info-circle" class="icon-info"/>
                {{ $t('system.pending') }}
              </span>
            </td>
            <td>
              <span>
                <Avatar :object="documentSingleTableItems[0].updated_by" size="xs" class="mr-2" v-if="documentSingleTableItems[0].updated_by"></Avatar>
                {{ documentSingleTableItems[0].updated_at | formatDate }}
              </span>
            </td>
            <td class="text-right">
              <span class="btn btn-edit"
                    qid="edit-p-modal"
                    @click="showEditDocumentsModal(documentSingleTableItems[0])"
                    v-if="isGranted([permissions.THIRD_PARTY_DOCUMENT_EDIT, permissions.THIRD_PARTY_DOCUMENT_EDIT_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
              >
                <font-awesome-icon icon="pen"/>
              </span>
              <button
                  @click="openViewDocumentModal(documentSingleTableItems[0])"
                  class="btn btn-view"
              >
                <font-awesome-icon icon="eye"/>
              </button>
            </td>
          </tr>
        </tbody>
      </table>


      <br>
      <div class="text-center mb-4 mt-2">
        <span class="cursor-pointer"
              @click="showHistoricDocuments = !showHistoricDocuments"
              qid="network-validation-expand"
        >
          <span class="mr-2">
            {{ $t('maintenance.third_parties.documents.historic_documents') }}
          </span>
          <font-awesome-icon icon="chevron-down" v-if="!showHistoricDocuments"/>
          <font-awesome-icon icon="chevron-up" v-if="showHistoricDocuments"/>
        </span>
      </div>

      <div v-show="showHistoricDocuments">
        <table class="table table-responsive-md">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('activities.measures.table.name') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.start_date') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.end_date') }}
            </th>
            <th scope="col" class="text-center">
              {{ $t('maintenance.third_parties.documents.attachments') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.signed') }}
            </th>
            <th scope="col">
              {{ $t('system.last_updated') }}
            </th>
            <th width="180"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(object, index) in documentSingleTableItems"
                v-if="index > 0"
            >
              <td>
                <button @click="openViewDocumentModal(object)"
                        class="btn btn-link btn-sm text-left"
                >
                  {{ object.name }}
                </button>
              </td>
              <td>
                <span v-if="object.start_date">
                  {{ object.start_date | formatDate }}
                </span>
              </td>
              <td>
                <span v-if="object.end_date">
                  {{ object.end_date | formatDate }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="(object.media && object.media.length) || (object.links && object.links.length)">
                  <font-awesome-icon icon="paperclip"/>
                </span>
              </td>
              <td>
                <span v-if="object.signed == 'yes'">
                  <font-awesome-icon icon="check-circle" class="icon-success mr-1"/>
                  {{ $t('system.yes') }}
                </span>
                <span v-if="object.signed == 'pending'">
                  <font-awesome-icon icon="info-circle" class="icon-info"/>
                  {{ $t('system.pending') }}
                </span>
              </td>
              <td>
                <span>
                  <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td class="text-right">
                <button @click="openViewDocumentModal(object)"
                        class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </button>
                <button class="btn btn-delete"
                        qid="delete-document-modal"
                        @click="showDocumentConfirmDeleteModal(object)"
                        v-if="isGranted([permissions.THIRD_PARTY_DOCUMENT_DELETE, permissions.THIRD_PARTY_DOCUMENT_DELETE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </td>
            </tr>
            <tr v-if="!measureLoading && documentSingleTableItems.length < 2" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideViewDocumentListModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>

      </div>
    </b-modal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import roleCheck from "@/util/ACL/roleCheck"
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import MeasureCreateForm from '@/views/Measures/MeasureCreateForm.vue'
  import Datepicker from 'vuejs-datepicker';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';


  export default {
    name: 'DocumentsTable',
    data: function() {
      return {
        form: {
          name: '',
          category: [],
          signed: [],
          start_date: '',
          end_date: '',
          links: []
        },
        editForm: {
          name: '',
          category: [],
          signed: [],
          start_date: '',
          end_date: '',
        },
        error: '',
        editError: '',
        loadingItems: false,
        selectedDocument: [],
        selectedTableItem: [],
        viewRRModal: false,
        editRRModal: false,
        selectedDocumentSort: '',
        selectedDocumentDirection: '',
        acValidationShow: false,
        documentTableItems: [],
        documentSingleTableItems: [],
        measureLoading: true,
        measureItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: undefined,
        disabledValidationOptions: [],
        showRRDescription: false,
        buttonDisabled: false,
        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        selectedItem: {},
        selectedParentDocument: {},
        viewMeasureModal: false,
        myGuides: [],
        selectedAnswer: [],
        selectedDate: '',
        selectedNumber: '',
        inputLinkName: '',
        inputLink: '',
        allAnswers: [],
        selectedFiles: [],
        categoryItems: [],
        categoryInput: '',
        signedItems: [
          { name: this.$t('system.yes'), value: 'yes' },
          { name: this.$t('system.pending'), value: 'pending' }
        ],
        checklistOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0},
        ],
        showHistoricDocuments: false,
        hasEndDate: 1,
        selectedViewItem: {},
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      tasks: {
        type: Array
      }
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      Datepicker,
      MeasureCreateForm,
      GuideButton,
      UpdateSingleTaskModal
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getFiles() {
        return this.selectedFiles
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadDocuments();
        this.loadCategories();
      },
      object: function (newValue) {
        if (newValue && newValue.id) {
          this.thirdParty = newValue
          this.loadTasks('update_documents');
          this.loadDocuments();
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.thirdParty.id && this.$store.state.updatedObject.who_am_i == this.thirdParty.who_am_i) {
              this.thirdParty = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_documents')
        }
      },
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadDocuments()
      }, 400),
      checkIfAdmin() {
        if (roleCheck('Client admin') || roleCheck('Partition admin')) {
          return true
        } else {
          return false
        }
      },
      openViewDocumentListModal(object) {
        this.selectedItem = object
        this.loadChildDocuments()
        this.$refs['view-document-list'].show()
      },
      hideViewDocumentListModal () {
        this.showHistoricDocuments = false;
        this.selectedItem = []
        this.$refs['view-document-list'].hide()
      },
      openViewDocumentModal(object) {
        this.selectedViewItem = object
        this.$refs['view-document'].show()
      },
      hideViewDocumentModal () {
        this.selectedViewItem = []
        this.$refs['view-document'].hide()
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadDocuments();
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Third party' && object.enabled
        });
        return existingGuide
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Third party',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.length; i++) {
          this.selectedFiles.push(files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      showCreateDocumentModal(parent) {
        this.loadCategories();
        this.form.name = ''
        this.form.start_date = ''
        this.form.end_date = ''
        this.form.signed = []
        this.form.category = []
        this.categoryInput = ''
        this.form.links = []
        this.selectedDocument = []
        this.selectedFiles = []
        this.selectedParentDocument = parent
        if (this.selectedParentDocument && this.selectedParentDocument.id) {
          this.form.name = this.selectedParentDocument.latest_version.name
        } else {
          this.form.name = ''
        }
        this.$refs['add-document'].show()
      },
      hideCreateDocumentModal() {
        this.error = ''
        this.selectedTableItem = []
        this.loadContent()
        this.loadCategories();
        this.selectedParentDocument = []
        this.$refs['add-document'].hide()
      },
      showEditDocumentsModal(object) {
        let self = this;
        this.loadCategories();
        this.selectedTableItem = object
        this.editForm.name = ''
        this.editForm.category = []
        this.categoryInput = ''
        this.editError = ''

        this.editForm.start_date = object.start_date
        this.editForm.end_date = object.end_date

        if (object.category) {
          this.editForm.category = []
          this.editForm.category = _.find(this.categoryItems, function(item) {
            return item.category === object.category;
          });
        }

        this.editForm.name = object.name;

        if (object.signed) {
          this.editForm.signed = _.find(this.signedItems, function(item) {
            return item.value === object.signed;
          });
        }

        this.$refs['edit-document'].show()
      },
      hideEditDocumentModal() {
        this.editError = ''
        this.editForm.signed = []
        this.editForm.name = '';
        this.editForm.start_date = '';
        this.editForm.end_date = '';
        this.selectedDocument = []
        this.loadContent()
        this.loadCategories();
        this.$refs['edit-document'].hide()
      },
      showDocumentConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-document'].show()
      },
      hideDocumentConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-document'].hide()
      },
      confirmDeleteDocument(object) {
        let self = this;
        piincHttp.delete('third-parties/' + this.thirdParty.slug + '/documents/' + object.id).then(function() {
          self.hideDocumentConfirmDeleteModal();
          self.loadChildDocuments();
          self.loadDocuments();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.third_parties.documents.delete.success'))
        }, function() {});
      },
      formSubmit(evt) {
        let formData = new FormData();
        let files = document.querySelector('#file');
        let sizeError = false;
        var moment = require('moment');

        this.handleLink();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // Append list of attachments to FormData
        for (var i = 0; i < this.selectedFiles.length; i++) {
          // Equal to 10 MB
          if (this.selectedFiles[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("files[]", this.selectedFiles[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.form.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.form.links[i]));
        }

        // Additional check - if category is selected, append it to form data
        if (this.form.category && this.form.category.category) {
          formData.append("category", this.form.category.category);
        } else {
          if (this.categoryInput && this.categoryInput.length) {
            formData.append("category", this.categoryInput);
          }
        }

        if (this.form.signed && this.form.signed.value) {
          formData.append("signed", this.form.signed.value);
        }

        if (this.selectedParentDocument && this.selectedParentDocument.id) {
          formData.append("third_party_document_id", this.selectedParentDocument.id);
        }

        formData.append("name", this.form.name);

        this.form.start_date = this.form.start_date ? moment(this.form.start_date).format('YYYY-MM-DD') : '';
        formData.append("start_date", this.form.start_date);

        this.form.end_date = this.form.end_date ? moment(this.form.end_date).format('YYYY-MM-DD') : '';
        formData.append("end_date", this.form.end_date);

        if (sizeError) {
          this.error = this.$t('system.file_size_30')
        } else {
          if (
              this.form.start_date && this.form.signed && this.form.signed.value &&
              ((this.form.category && this.form.category.category) || (this.categoryInput && this.categoryInput.length)) &&
              ((this.selectedFiles && this.selectedFiles.length) || (this.form.links && this.form.links.length))
          ) {
            this.buttonDisabled = true;
            piincHttp.post('/third-parties/' + this.thirdParty.slug + '/documents', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.loadChildDocuments()
              self.loadDocuments(self.currentPage);
              self.$toastr('success', self.$t('maintenance.third_parties.documents.update_success'))
              self.hideCreateDocumentModal();

              self.$emit('updated');
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
                if (error.data.errors.measure_id) {
                  self.error += ' ' + error.data.errors.measure_id[0]
                }
              }
            })
          } else {
            this.error = ''
            if (!this.form.start_date) {
              this.error += this.$t('maintenance.third_parties.documents.start_date_error')
            }
            if (!this.form.signed || (this.form.signed && !this.form.signed.value)) {
              this.error +=  ' ' + this.$t('maintenance.third_parties.documents.signed_error')
            }
            if ((!this.form.category || (this.form.category && !this.form.category.category)) && !this.categoryInput.length) {
              this.error +=  ' ' +  this.$t('maintenance.third_parties.create.category_error')
            }
            if ((this.selectedFiles && !this.selectedFiles.length) && (this.form.links && !this.form.links.length)) {
              this.error += ' ' + this.$t('tasks.modal.attachments_error_message')
            }
            this.buttonDisabled = false;
          }

        }

      },
      formEditSubmit(evt) {

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        var moment = require('moment');
        evt.preventDefault();

        if (
          this.editForm.start_date && this.editForm.signed && this.editForm.signed.value &&
          ((this.editForm.category && this.editForm.category.category) || (this.categoryInput && this.categoryInput.length))
        ) {
          this.buttonDisabled = true;

          this.editForm.signed = this.editForm.signed ? this.editForm.signed.value : ''

          if (this.categoryInput && this.categoryInput.length) {
            this.editForm.category = this.categoryInput
          } else {
            if (this.editForm.category && this.editForm.category.category) {
              this.editForm.category = this.editForm.category.category
            } else {
              this.editForm.category = '';
            }
          }

          this.editForm.start_date = this.editForm.start_date ? moment(this.editForm.start_date).format('YYYY-MM-DD') : ''
          this.editForm.end_date = this.editForm.end_date ? moment(this.editForm.end_date).format('YYYY-MM-DD') : ''

          piincHttp.put('/third-parties/' + this.thirdParty.slug + '/documents/' + this.selectedTableItem.id, this.editForm).then(function(response) {
            self.hideEditDocumentModal();
            self.loadDocuments(self.currentPage);
            self.loadChildDocuments();
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.third_parties.documents.update_success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.editError = error.data.message;
            }
          })

        } else {
          this.editError = ''
          if ((!this.editForm.category || (this.editForm.category && !this.editForm.category.category)) && !this.categoryInput.length) {
            this.editError +=  ' ' +  this.$t('maintenance.third_parties.create.category_error')
          }
          if (!this.editForm.start_date) {
            this.editError += this.$t('maintenance.third_parties.documents.start_date_error')
          }
          if (!this.editForm.signed || (this.editForm.signed && !this.editForm.signed.value)) {
            this.editError +=  ' ' + this.$t('maintenance.third_parties.documents.signed_error')
          }
          this.buttonDisabled = false;
        }

      },
      loadContent() {
        let self = this;
        piincHttp.get('third-parties/' + this.thirdParty.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.thirdParty = response.data;
        }, function() {});
      },
      loadDocuments(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;

        piincHttp.get('third-parties/' + this.thirdParty.slug + '/documents', { params:
            {
              page: pageNumber,
              per_page: perPageNumber,
              sort: this.selectedSort !== '' ? this.selectedSort : undefined,
              order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
              keyword: this.keywordValue !== '' ? this.keywordValue : undefined,
              client: this.getClient.slug
            }
        }).then(function(response) {

          self.measureLoading = false;
          self.documentTableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});
      },
      reloadContent() {
        this.loadTasks('update_documents');
        this.loadDocuments();
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.thirdParty.who_am_i,
              model_id: this.thirdParty.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      loadChildDocuments() {
        let self = this;

        piincHttp.get('third-parties/' + this.thirdParty.slug + '/documents', { params:
          {
            third_party_document_id: this.selectedItem.id,
            per_page: 100,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.keywordValue !== '' ? this.keywordValue : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.measureLoading = false;
          self.documentSingleTableItems = response.data.items;
        }, function() {});
      },
      loadCategories(query) {
        let self = this;
        piincHttp.get('/third-parties/documents/categories', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.categoryItems = response.data
          if (self.categoryItems && !self.categoryItems.length && !query) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      pageChanged(page) {
        // Load Third parties when page changed listener is triggered
        this.loadDocuments(page)
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        // Load Third parties when page changed listener is triggered
        this.loadDocuments(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        // Load Third parties when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadDocuments(1, self.selectedPerPage)

      },
    },
    created () {
      this.thirdParty = this.object
      if (this.getClient && this.getClient.slug) {
        this.loadCategories();
      }

      if (this.thirdParty && this.thirdParty.id) {
        this.loadDocuments();
      }

      this.loadGuides('update_documents')
    }
  }
</script>
